import { render, staticRenderFns } from "./Monitoring-Setting.vue?vue&type=template&id=3ab5fa2d&scoped=true"
import script from "./Monitoring-Setting.vue?vue&type=script&lang=js"
export * from "./Monitoring-Setting.vue?vue&type=script&lang=js"
import style0 from "./Monitoring-Setting.vue?vue&type=style&index=0&id=3ab5fa2d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab5fa2d",
  null
  
)

export default component.exports